import { render, staticRenderFns } from "./add-participant-modal.vue?vue&type=template&id=084d6776"
import script from "./add-participant-modal.vue?vue&type=script&lang=ts"
export * from "./add-participant-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports